import { render, staticRenderFns } from "./ExpenseCrud.vue?vue&type=template&id=6b6cd3de&scoped=true"
import script from "./ExpenseCrud.vue?vue&type=script&lang=js"
export * from "./ExpenseCrud.vue?vue&type=script&lang=js"
import style0 from "./ExpenseCrud.vue?vue&type=style&index=0&id=6b6cd3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6cd3de",
  null
  
)

export default component.exports